function ScrollToButtons() {

    const pageDoc = document.querySelector('body')
    const scrollTopButton  = document.querySelector('.back-to-top__button')

    gsap.set(scrollTopButton, { y: 50 })    
    gsap.to(scrollTopButton, {
        y: 0,
        autoAlpha: 1,
        scrollTrigger: {
            trigger: pageDoc,
            start: '15%',
            end: '30%',
            toggleActions: "play none reverse none",            
        }
    })

    scrollTopButton.addEventListener("click", () => gsap.to(window, { scrollTo: 0 }))
}

export default ScrollToButtons